module.exports = __webpack_public_path__ + "img/구름많고눈.1babe76e.png";